var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoData = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 101,
  height: 100,
  viewBox: "0 0 101 100"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.5 98c26.51 0 48-21.49 48-48S77.01 2 50.5 2s-48 21.49-48 48 21.49 48 48 48m0 2c-27.614 0-50-22.386-50-50s22.386-50 50-50 50 22.386 50 50-22.386 50-50 50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.955 40.534c0-.77.692-1.394 1.545-1.394s1.545.624 1.545 1.394v12.99c0 .77-.692 1.394-1.545 1.394s-1.545-.624-1.545-1.394zM50.5 61.378c-1.112 0-2.014-.814-2.014-1.817s.902-1.818 2.014-1.818 2.014.814 2.014 1.818c0 1.003-.902 1.817-2.014 1.817m-27.865 8.088c-.861 0-1.408-.832-.994-1.513l27.865-45.955c.43-.709 1.558-.709 1.988 0l27.865 45.955c.414.681-.133 1.513-.994 1.513zm1.912-2.045h51.906L50.5 24.62z"
}))));
export default SvgNoData;